import React, { memo } from 'react';
export function ReframeSection() {
  return <section className="bg-forest py-[70px] px-5 text-center relative overflow-hidden reframe reveal" data-id="element-258">
      <div className="absolute inset-0 bg-reframe-pattern pointer-events-none" data-id="element-259" />

      <div className="relative z-10" data-id="element-260">
        <h2 className="font-playfair text-[clamp(1.8rem,3.5vw,2.6rem)] font-bold text-cream mb-3.5 leading-[1.2]" data-id="element-261">
          El problema no es tu hijo.
        </h2>

        <p className="text-cream/80 font-lora text-base max-w-[580px] mx-auto mb-5 leading-[1.8]" data-id="element-262">
          La mayoría de los niños no tiene un problema de inteligencia.
          <br data-id="element-263" />
          Lo que tienen es una{' '}
          <span className="inline-block bg-terracotta text-white py-[3px] px-2.5 rounded-[3px] font-medium" data-id="element-264">
            activación incorrecta
          </span>{' '}
          de los sonidos en el{' '}
          <span className="inline-block bg-gold text-forest-dark py-[3px] px-2.5 rounded-[3px] font-medium" data-id="element-265">
            orden incorrecto
          </span>
          .
        </p>

        <p className="text-cream/80 font-lora text-base max-w-[580px] mx-auto mb-5 leading-[1.8]" data-id="element-266">
          Han intentado memorizar palabras completas sin entender cómo se
          construyen. Cuando el niño entiende el proceso, deja de sentirse
          "tonto".
        </p>

        <p className="text-cream/80 font-lora text-base max-w-[580px] mx-auto mb-5 leading-[1.8]" data-id="element-267">
          <strong className="text-cream font-bold" data-id="element-268">
            Y cuando se siente capaz, empieza a intentar.
          </strong>
        </p>

        <div className="max-w-[620px] mx-auto mt-8 bg-white/10 border border-white/15 rounded-lg py-[18px] px-6 flex items-start gap-4 text-left" data-id="element-269">
          <div className="text-[1.5rem] shrink-0 mt-0.5" data-id="element-270">🔬</div>
          <div className="font-sans text-[0.85rem] text-cream/85 leading-[1.6]" data-id="element-271">
            <strong className="text-cream block mb-1 text-[0.9rem]" data-id="element-272">
              Respaldado por la investigación en lectura inicial
            </strong>
            La instrucción fonética sistemática — el corazón de este método — es
            el enfoque que la <em className="italic" data-id="element-273">National Reading Panel</em>{' '}
            (EE.UU.) y referentes como <em className="italic" data-id="element-274">Louisa Moats</em>{' '}
            llevan décadas señalando como el más efectivo para niños de 4 a 9
            años. No es una tendencia. Es ciencia.
          </div>
        </div>

        <p className="font-playfair text-[1.3rem] italic text-cream mt-7 opacity-90" data-id="element-275">
          "La lectura nace de la comprensión, no de la repetición."
        </p>
      </div>
    </section>;
}